import { CAISO_UNCONSTRAINED_SENTINEL_MW } from "types/busFilterTypes";

export const getFormattedCost = (cost: number): string => {
    return `$${(cost / 1000000).toFixed(1)}M`;
};

// The CAISO sentinel is a flag, not a measured capacity; show no number.
export const maybeUnconstrainedThresholdLabel = (
    injectionThreshold: number
): string | undefined => {
    return injectionThreshold === CAISO_UNCONSTRAINED_SENTINEL_MW
        ? "No constraints identified"
        : undefined;
};

export const formatPercentString = (
    decimal: number,
    percentDecimalPlaces = 0
): string => {
    return `${(decimal * 100).toFixed(percentDecimalPlaces)}%`;
};
